import { render, staticRenderFns } from "./Atendimento.vue?vue&type=template&id=3ee67edc"
import script from "./Atendimento.vue?vue&type=script&lang=js"
export * from "./Atendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports